import { useLayoutEffect, useRef } from 'react';

// calls fn with the current closure data
export const useUnmount = (fn: () => void) => {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useLayoutEffect(() => () => fnRef.current(), []);
};
